import React, { Component } from 'react';
import { Button, Tooltip } from '@trevor/ui-components';

class ShareIcon extends Component {
  render() {
    const { id, children, onClick, tooltip, disabled, place } = this.props;

    const disabledTooltip = () => {
      return this.props.disabledTip || '(save query first)';
    };

    return (
      <>
        <div data-tooltip-id={id}>
          <Button
            variant="secondary"
            size="small"
            onClick={disabled ? null : onClick}
            disabled={disabled}
            icon={children}
          />
        </div>
        <Tooltip id={id} place={place || 'bottom'}>
          {tooltip}
          {disabled ? <span>&nbsp;{disabledTooltip()}</span> : ''}
        </Tooltip>
      </>
    );
  }
}

export default ShareIcon;
